export default __webpack_public_path__ + "static/nl-e16ed416b10f1e72ec1bc1fd56a97a3c.svg";